export const ENDPOINTS = {
    HUBSPOT_COMPANY_URL: 'https://app.hubspot.com/contacts/8339245/record/0-2',
    SANITY_INSIGHTS_URL: 'https://pcg.io',
}